import { ContentType, NotificationItemType } from '@atlassian/learning-components';

export interface NotificationItem {
  id: number;
  entryContentfulId: string;
  contentfulType: ContentType;
  notificationContentfulId: string;
  publishedAt: string;
  title: string;
  description: string;
  slug: string;
}

export interface NotificationsResponse {
  historicalNotifications: NotificationItem[];
  unseenNotifications: NotificationItem[];
}

export interface NotificationsMappedResponse {
  historicalNotifications: NotificationItemType[];
  unseenNotifications: NotificationItemType[];
}

export enum NotificationType {
  HISTORICAL = 'historical',
  UNSEEN = 'unseen',
}

export const viewNotifications = async (contentfulNotificationIds: number[]): Promise<boolean> => {
  const res = await fetch(
    `${globalThis?.location?.origin}/gateway/api/learning-app-progress-fe/notifications/acknowledge`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ contentfulNotificationIds }),
    },
  );

  return res.status === 200;
};

export const getNotificationsById = async (
  contentfulId: string,
  contentType: ContentType,
): Promise<NotificationsResponse | null> => {
  const res = await fetch(
    `${globalThis?.location?.origin}/gateway/api/learning-app-progress-fe/notifications?contentType=${contentType}&contentfulContentId=${contentfulId}`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (res.status !== 200) {
    return null;
  }

  return res.json();
};
